import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"

function DeliveryOrderItem(props){
    const [data]=useState(props.item);
    const navigate=useNavigate();

    const orderDetailFynctionality = () => {
    //dispatch(updateFormInfo({ displayForm: false, formData: { order } }));

    navigate("/orderDetails", { state: { order: props.item, from: "store" } });
  };

  const storeInfoPage = () => {
    // dispatch(updateFormInfo({ displayForm: false, formData: { product } }));
    navigate("/uniqueStore", {
      state: {
        storeId: data.store_id,
        storeName: data.store_name,
        storeAddress: "",
        event:"orders"
      },
    });
  };

     function Temp(status) {
    switch (status) {
      case "0":
        return <span style={{ color: "black" }}>Pending</span>;

      case "1":
        return <span style={{ color: "pinkAccent" }}>Accepted</span>;

      case "2":
        return <span style={{ color: "blueAccent" }}>Assigned</span>;

      case "3":
        return <span style={{ color: "#FF8C00" }}>Picked Up</span>;
      case "4":
        return <span style={{ color: "green" }}>Delivered</span>;
      case "5":
        return <span style={{ color: "green" }}>Delivered</span>;
      case "6":
        return <span style={{ color: "red" }}>Cancelled</span>;
      case "7":
        return <span style={{ color: "black" }}>Rejected</span>;
      case "8":
        return (
          <span style={{ color: "0xffcc0d0d" }}>Order Cancel Request</span>
        );
    }
  }
    return(
        <>
        <tr>
            <td>{props.sno}</td>
            <td>{data.dated}</td>
            <td onClick={orderDetailFynctionality}><Link>#EP0{data.order_id}</Link></td>
            <td>{data.total_price}</td>
            <td onClick={storeInfoPage}><Link>{data.store_name}</Link></td>
            <td>{data.customerName}</td>
            <td>{data.landmark}</td>
            <td>{Temp(data.status)}</td>
            <td>{data.payment_type}</td>
            
        </tr>
        </>
    )
}

export default DeliveryOrderItem